import { Controller } from '@hotwired/stimulus';
import { showConfirmModal } from 'application/toolkit/ag_grid_shared/confirm_modal';

// Gates a form submit behind the shared warning modal the admin grids use.
// Attach to the <form>, with `submit->confirm-submit#confirm`.
export default class extends Controller {
  static values = {
    message: String,
    title: String,
    confirmLabel: String,
  };

  connect() {
    this.confirmed = false;
  }

  async confirm(event) {
    // Second pass, fired by our own requestSubmit below — let it through.
    if (this.confirmed) return;

    event.preventDefault();

    const confirmed = await showConfirmModal({
      title: this.hasTitleValue ? this.titleValue : undefined,
      danger: this.messageValue,
      confirmLabel: this.hasConfirmLabelValue ? this.confirmLabelValue : undefined,
    });
    if (!confirmed) return;

    this.confirmed = true;
    // requestSubmit, not submit() — re-fires the submit event so Turbo still handles it.
    this.element.requestSubmit();
  }
}
